import { ViewBreadcrumbModel } from "../../Models/ViewBreadcrumbModel";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";
import ViewBreadcrumbs from "./ViewBreadcrumbs";

function ViewBreadcrumbsComponent({ component, context }: IComponentProps<ViewBreadcrumbModel>) {
  const label = component.Label || "Breadcrumb";
  const componentLayoutSx = getComponentLayout(component);

  return <ViewBreadcrumbs label={label} sx={componentLayoutSx} />;
}

export default ViewBreadcrumbsComponent;
